"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var gatsby_background_image_1 = __importDefault(require("gatsby-background-image"));

var styled_components_1 = __importDefault(require("styled-components"));

var util_1 = require("../../accessors/util");

var uniqid = require('uniqid');

var BackgroundContainer = function BackgroundContainer(_a) {
  var data = _a.data,
      children = _a.children,
      _b = _a.contain,
      contain = _b === void 0 ? false : _b;
  var fluid = data.fluid({
    fallbackImage: util_1.defaultFallbackImage
  });

  if (fluid) {
    return react_1["default"].createElement(GatsbyBackgroundImageContainer, null, react_1["default"].createElement(gatsby_background_image_1["default"], {
      classId: uniqid(),
      fluid: fluid,
      style: {
        backgroundSize: contain ? 'contain' : 'cover'
      }
    }, children));
  } else return null;
};

exports.BackgroundImage = BackgroundContainer; // had to use inline styles, to prevent invalid prop on DOM el error

var GatsbyBackgroundImageContainer = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1;